import { createContext, useContext } from "react";
import type { IComboBoxContext } from "./types";

const ComboBoxContext = createContext<IComboBoxContext | undefined>(undefined);

export const ComboBoxProvider = ComboBoxContext.Provider;

export const useComboBoxContext = () => {
  const context = useContext(ComboBoxContext);
  if (!context) {
    throw new Error(
      "useComboBoxContext must be used within a ComboBoxProvider",
    );
  }
  return context;
};
